import React from 'react';
import PropTypes from 'prop-types';

const ProfileTickSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 16}`}
      height={`${height || 16}`}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.62695 12.7L10.6403 13.7133L12.667 11.6867"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.10673 7.24666C8.04006 7.24 7.96006 7.24 7.88673 7.24666C6.30006 7.19333 5.04006 5.89333 5.04006 4.29333C5.0334 2.65999 6.36006 1.33333 7.9934 1.33333C9.62673 1.33333 10.9534 2.65999 10.9534 4.29333C10.9534 5.89333 9.68673 7.19333 8.10673 7.24666Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99336 14.54C6.78003 14.54 5.57336 14.2333 4.65336 13.62C3.04003 12.54 3.04003 10.78 4.65336 9.70667C6.48669 8.48 9.49336 8.48 11.3267 9.70667"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ProfileTickSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ProfileTickSvg;
